module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cta":"We make it happen, read more"},"nl":{"cta":"Kan gewoon, lees meer"}}')
  delete Component.options._Ctor
}
